<template>
    <div class="products-item">
        <a :href="productItem.Url" class="products-item__link-wrap">
            <div class="products-item__inner">
                <ResponsiveImage v-if="productItem.ImageHtml.Src || productItem.ImageHtml.HasCrop" :imageModel="productItem.ImageHtml" wrapClass="products-item__image" />
                <div class="products-item__text">
                    <div class="products-item__text-row">
                        <h3 class="products-item__headline">{{productItem.ListHeadline}}</h3>
                        <p class="products-item__teaser" v-if="productItem.HasListTeaser" v-html="productItem.ListTeaser"></p>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import ResponsiveImage from "./responsiveImage.vue";

    export default {
        name: "productItem",
        components: {
        ResponsiveImage
    },
        props: ["productItem"]
    };
</script>